import React from "react";
import { FaInstagram, FaTiktok, FaYoutube, FaFacebook } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="bg-white dark:bg-gray-900 text-white py-4">
      <div className="container mx-auto px-4 flex flex-col md:flex-row items-center justify-between">
        {/* Footer Text */}
        <div className="text-center md:text-left">
          <p className="text-sm text-gray-700 dark:text-gray-300 hover:text-brandcolour">
            &copy; {new Date().getFullYear()} HaZe IT Solutions. All Rights Reserved.
          </p>
        </div>

        {/* Social Links */}
        <div className="flex items-center space-x-4 mt-4 md:mt-0">
          <a
            href="https://www.instagram.com/haze_itsolutions/?utm_source=qr#"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-700 dark:text-gray-300 hover:text-brandcolour"
            aria-label="Visit HaZe IT Solutions on Instagram"
          >
            <FaInstagram size={24} />
          </a>
          <a
            href="https://www.tiktok.com/@hazeitsolutions?is_from_webapp=1&sender_device=pc"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-700 dark:text-gray-300 hover:text-brandcolour"
            aria-label="Visit HaZe IT Solutions on TikTok"
          >
            <FaTiktok size={24} />
          </a>
          <a 
            href="https://www.youtube.com/channel/UCq8nwanFzFSTGLXUINb7JWA"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-700 dark:text-gray-300 hover:text-brandcolour"
            aria-label="Visit HaZe IT Solutions on YouTube"
          >
            <FaYoutube size={24} />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
